const POLICY_PATH = {
  INDEX: '/policy',
  POLICY_TERM: '/policy#terms',
  POLICY_REVENUE: '/policy#revenue',
  POLICY_PRIVACY: '/policy#privacy',
  POLICY_REGULATION: '/policy#regulation',
  POLICY_YOUTH: '/policy#youth',
};

const AUTH_PATH = {
  SIGN_IN: '/sign-in',
  SIGN_IN_WITH_PASSWORD: '/sign-in/password',
  PASSWORD_FORGOT: '/password-forgot',
};

export const PATH = {
  MAIN: '/',
  DASHBOARD: '/dashboard',
  POLICY: POLICY_PATH,
  AUTH: AUTH_PATH,
};
